module.exports = __webpack_public_path__ + "img/icon-checkbox.7dff6ea9.svg";